import { QueryEntity } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { LineChartStore, LineChartState } from './line-chart.store';

@Injectable({
	providedIn: 'root'
})
export class LineChartQuery extends QueryEntity<LineChartState> {
	events$ = this.select(state => state.ui.events);
	datePeriod$ = this.select(state => state.ui.datePeriod);
	selectedUsers$ = this.select(state => state.ui.selectedUsers);
	dateFormat$ = this.select(state => state.ui.dateFormat);
	chartLoading$ = this.select(state => state.ui.chartLoading);
	usersInfo$ = this.select(state => state.ui.usersInfo);
  chartType$ = this.select(state => state.ui.chartType);


	constructor(protected store: LineChartStore) {
		super(store);
	}
}
